/** hg-order's shapes, as this feature uses them: names for the generated types. */
import type { components } from "@/shared/api/order.schema";

type Schemas = components["schemas"];

/** Where a specialist at work is now. */
export type Position = Schemas["PositionResponse"];
/** A specialist's road through a span of time. */
export type Track = Schemas["TrackResponse"];
export type TrackPoint = Schemas["TrackPointResponse"];
/** The road of one visit: where it went, its moments, the points taken on the way and at it. */
export type VisitTrack = Schemas["VisitTrackResponse"];

/** The spans a specialist's road can be asked for, in hours. The service gives a day at most. */
export const SPANS = [2, 6, 12, 24] as const;
export type Span = (typeof SPANS)[number];
/** What the service takes when no span is given. */
export const DEFAULT_SPAN: Span = 2;

/**
 * A span of one's own choosing: two moments by the market's clock, as a
 * `datetime-local` field holds them (`2026-10-03T08:00`). Without an end it
 * runs up to now. The service gives a day at most.
 */
export interface OwnSpan {
  from: string;
  to?: string;
}

/** Whose road is asked for how long: the last hours, or a span of one's own. */
export type RoadSpan = Span | OwnSpan;
